// Story 10.1 — AppShell: sidebar + top bar + content area con outlet.
// `<main id="main-content">` es el target del skip-link en `index.html`.

import { Outlet } from '@tanstack/react-router';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

export function AppShell(): React.ReactElement {
  return (
    // `h-dvh`: en móvil `100vh` incluye la barra del navegador y cortaba el
    // final de cada página.
    <div className="flex h-dvh overflow-hidden bg-background text-foreground">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <TopBar />
        <main id="main-content" className="flex-1 overflow-y-auto p-4 md:p-6" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
